import { createFileRoute } from "@tanstack/react-router";
import { StudyGroupInvitePage } from "@/features/study-group-invite/components/StudyGroupInvitePage";

export const Route = createFileRoute("/study-groups/invite/$token")({
  component: StudyGroupInvitePage,
});
